import { baseApi } from "@/shared/api";
import type { PendingActionsResponse } from "../types/pending.types";

export const pendingActionsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPendingActions: builder.query<PendingActionsResponse, void>({
      query: () => ({
        url: "/api/actions/pending/",
        method: "GET",
        credentials: "include" as const,
      }),
      providesTags: [{ type: "PendingActions", id: "LIST" }],
    }),
  }),
});

export const { useGetPendingActionsQuery } = pendingActionsApi;
